export default "__VITE_PUBLIC_ASSET__6b8dc065__"